import { render, staticRenderFns } from "./WidgetUpdate.vue?vue&type=template&id=73600e43&scoped=true&"
import script from "./WidgetUpdate.vue?vue&type=script&lang=js&"
export * from "./WidgetUpdate.vue?vue&type=script&lang=js&"
import style0 from "./WidgetUpdate.vue?vue&type=style&index=0&id=73600e43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73600e43",
  null
  
)

export default component.exports